// src/components/PdfWhiteboard/constants/scales.js
export const METRIC_SCALES = [
  { key: 'metric_1', label: '1:1', ratio: 1, documentUnit: 'mm' },
  { key: 'metric_5', label: '1:5', ratio: 5, documentUnit: 'mm' },
  { key: 'metric_10', label: '1:10', ratio: 10, documentUnit: 'mm' },
  { key: 'metric_20', label: '1:20', ratio: 20, documentUnit: 'mm' },
  { key: 'metric_25', label: '1:25', ratio: 25, documentUnit: 'mm' },
  { key: 'metric_50', label: '1:50', ratio: 50, documentUnit: 'mm' },
  { key: 'metric_75', label: '1:75', ratio: 75, documentUnit: 'mm' },
  { key: 'metric_100', label: '1:100', ratio: 100, documentUnit: 'mm' },
  { key: 'metric_125', label: '1:125', ratio: 125, documentUnit: 'mm' },
  { key: 'metric_200', label: '1:200', ratio: 200, documentUnit: 'mm' },
  { key: 'metric_250', label: '1:250', ratio: 250, documentUnit: 'mm' },
  { key: 'metric_500', label: '1:500', ratio: 500, documentUnit: 'mm' },
  { key: 'metric_1000', label: '1:1000', ratio: 1000, documentUnit: 'mm' },
];

export const IMPERIAL_SCALES = [
  { key: 'imperial_1_128_ft', label: '1/128" = 1\'-0"', ratio: (12 * 128), documentUnit: 'in' },
  { key: 'imperial_1_64_ft', label: '1/64" = 1\'-0"', ratio: (12 * 64), documentUnit: 'in' },
  { key: 'imperial_1_32_ft', label: '1/32" = 1\'-0"', ratio: (12 * 32), documentUnit: 'in' },
  { key: 'imperial_1_16_ft', label: '1/16" = 1\'-0"', ratio: (12 * 16), documentUnit: 'in' },
  { key: 'imperial_3_32_ft', label: '3/32" = 1\'-0"', ratio: (12 * 32 / 3), documentUnit: 'in' },
  { key: 'imperial_1_8_ft', label: '1/8" = 1\'-0"', ratio: (12 * 8), documentUnit: 'in' },
  { key: 'imperial_3_16_ft', label: '3/16" = 1\'-0"', ratio: (12 * 16 / 3), documentUnit: 'in' },
  { key: 'imperial_1_4_ft', label: '1/4" = 1\'-0"', ratio: (12 * 4), documentUnit: 'in' },
  { key: 'imperial_3_8_ft', label: '3/8" = 1\'-0"', ratio: (12 * 8 / 3), documentUnit: 'in' },
  { key: 'imperial_1_2_ft', label: '1/2" = 1\'-0"', ratio: (12 * 2), documentUnit: 'in' },
  { key: 'imperial_3_4_ft', label: '3/4" = 1\'-0"', ratio: (12 * 4 / 3), documentUnit: 'in' },
  { key: 'imperial_1_ft', label: '1" = 1\'-0"', ratio: 12, documentUnit: 'in' },
  { key: 'imperial_1_1_in', label: '1:1 (inch)', ratio: 1, documentUnit: 'in' },
];

export const DEFAULT_METRIC_SCALE_KEY = METRIC_SCALES.find(s => s.label === '1:100')?.key || METRIC_SCALES[0].key;
export const DEFAULT_IMPERIAL_SCALE_KEY = IMPERIAL_SCALES.find(s => s.label === '1/4" = 1\'-0"')?.key || IMPERIAL_SCALES[0].key;